import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import ObjectiveOption from './objective-option';
import FormSection from '../../ui/form-elements/form-page/form-section';
import Button from '../../ui/button';

const ObjectivesPage = props => {
  const { strategy, merchantId, strategyGroupId, onSubmit, formError, setIsDirty } = props;
  const [selectedOption, setSelectedOption] = useState();
  const [pageFormError, setPageFormError] = useState();
  const history = useHistory();

  useEffect(() => {
    setPageFormError(formError);
  }, [formError]);

  useEffect(() => {
    setSelectedOption(strategy.strategy_type);
  }, [strategy.strategy_type]);

  const handleSelectOption = selectedOption => {
    setIsDirty(true);
    setSelectedOption(selectedOption);
  };

  const handleSubmit = () => {
    if (!selectedOption) {
      setPageFormError('Selection is required');
    } else {
      onSubmit(selectedOption);
    }
  };

  return (
    <div className="objectives-page">
      <FormSection>
        <div className="objectives-header">
          <div className="title">Select Objectives</div>
          <div className="subtitle">What is your objective for this Campaign?</div>
        </div>
        <div className="objective-options">
          <div className="objectives-row">
            <ObjectiveOption
              name="default"
              selectedOption={selectedOption}
              onClick={handleSelectOption}
            />
            <ObjectiveOption
              name="sale"
              selectedOption={selectedOption}
              onClick={handleSelectOption}
            />
            <ObjectiveOption
              name="product_launch"
              selectedOption={selectedOption}
              onClick={handleSelectOption}
            />
          </div>
          <div className="objectives-row">
            <ObjectiveOption
              name="product_category"
              selectedOption={selectedOption}
              onClick={handleSelectOption}
            />
            <ObjectiveOption
              name="hero_products"
              selectedOption={selectedOption}
              onClick={handleSelectOption}
            />
            <ObjectiveOption
              name="keywords"
              selectedOption={selectedOption}
              onClick={handleSelectOption}
            />
          </div>
        </div>
      </FormSection>
      <FormSection>
        <div className="form-buttons">
          <div className="left" />
          <div className="right">
            <span className="form-error">{pageFormError}</span>
            <Button
              onClick={e => {
                e.preventDefault();
                history.push(
                  `/v2/merchant/${merchantId}/campaign-center/campaigns?strategy_group_ids=${strategyGroupId}`,
                );
              }}
              label="Cancel"
              kind="text"
              size="large"
            />
            <Button onClick={handleSubmit} label="Save and Continue" size="large" />
          </div>
        </div>
      </FormSection>
    </div>
  );
};

export default ObjectivesPage;
